import { LogLevel } from '@azure/msal-browser';
import Constants from './constants';

export const msalConfig = {
  auth: {
    clientId: Constants.adClientId,
    authority: `https://login.microsoftonline.com/${Constants.adTenantId}`,
    redirectUri: `${window.location.origin}${Constants.basePath}`,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (!Constants.logAuth) {
          return;
        }

        if (containsPii) {
          console.warn('MSAL Logging - contains PII (Personally Identifiable Information) data');
        }

        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            console.error(`unrecognised log level: ${level}; message: ${message}`);
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const scopes = [];

// NOTE: API scopes are not required on initial login. Scopes area added when calling getTokenSilent.
export const loginRequest = {
  scopes,
};
